import type { InstallationLocation } from '~/ui-blocks/Formalization/blocks/electricityBill/electricityBill.utils'
import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useGridAccessApproval(projectId: Ref<string>, location: Ref<InstallationLocation | null>) {
  const queryKey = computed(() => queryKeys.REGISTRATION.GRID_ACCESS_APPROVAL(
    projectId.value,
    location.value?.city ?? '',
    location.value?.state ?? '',
  ))

  const queryFn = async () => {
    const res = await financialBff('query')({
      registration_grid_access_approval: [{
        project_id: projectId.value,
        city: location.value?.city ?? '',
        state: location.value?.state ?? '',
      }, {
        display_mode: true,
      }],
    })

    return res.registration_grid_access_approval
  }

  return useQuery({
    queryKey,
    queryFn,
    enabled: computed(() => Boolean(projectId.value && location.value)),
    retry: 0,
  })
}

export type UseGridAccessApproval = ReturnType<typeof useGridAccessApproval>
export type UseGridAccessApprovalData = UseGridAccessApproval['data']['value']
